module.exports = __webpack_public_path__ + "img/isacio.b652d26c.png";